(function () {
  'use strict';

  var STORAGE_KEY = 'keos_species';

  /* ---------- Species state (shared across every section) ---------- */
  function readSpecies() {
    try { return localStorage.getItem(STORAGE_KEY); } catch (e) { return null; }
  }
  function writeSpecies(value) {
    try { localStorage.setItem(STORAGE_KEY, value); } catch (e) { /* storage unavailable */ }
  }
  function applySpecies(species) {
    document.querySelectorAll('[data-kx-species-btn]').forEach(function (btn) {
      var on = btn.getAttribute('data-kx-species-btn') === species;
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
      btn.classList.toggle('is-active', on);
    });
    document.querySelectorAll('[data-kx-for]').forEach(function (el) {
      el.hidden = el.getAttribute('data-kx-for') !== species;
    });
    document.documentElement.setAttribute('data-kx-species', species);
  }
  function setSpecies(species) {
    if (species !== 'cat' && species !== 'dog') return;
    writeSpecies(species);
    applySpecies(species);
    document.dispatchEvent(new CustomEvent('keos:species', { detail: { species: species } }));
  }
  window.KeosSpecies = { set: setSpecies, get: function () { return readSpecies() || 'dog'; } };

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-kx-species-btn]');
    if (btn) { e.preventDefault(); setSpecies(btn.getAttribute('data-kx-species-btn')); }
  });

  /* ---------- Scroll reveal ---------- */
  function initReveal() {
    var items = document.querySelectorAll('[data-kx-reveal]:not(.is-in)');
    if (!('IntersectionObserver' in window)) { items.forEach(function (el) { el.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) { entry.target.classList.add('is-in'); io.unobserve(entry.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    items.forEach(function (el) { io.observe(el); });
  }

  /* ---------- Shared helpers ---------- */
  var toast;
  function showToast(html) {
    if (!toast) {
      toast = document.createElement('div');
      toast.className = 'kx-toast kx';
      toast.setAttribute('role', 'status');
      toast.setAttribute('aria-live', 'polite');
      document.body.appendChild(toast);
    }
    toast.innerHTML = html;
    toast.classList.add('is-on');
    clearTimeout(toast._t);
    toast._t = setTimeout(function () { toast.classList.remove('is-on'); }, 5000);
  }
  var live;
  function announce(msg) {
    if (!live) {
      live = document.createElement('div');
      live.className = 'kx-sr';
      live.setAttribute('aria-live', 'polite');
      document.body.appendChild(live);
    }
    live.textContent = '';
    setTimeout(function () { live.textContent = msg; }, 60);
  }
  function track(name, data, standard) {
    data = data || {};
    try { if (typeof window.fbq === 'function') window.fbq(standard ? 'track' : 'trackCustom', name, data); } catch (e) { /* no pixel */ }
    try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish(name, data); } catch (e) { /* no analytics */ }
  }
  window.KeosTrack = track;
  function setCartCount(count, pop) {
    document.querySelectorAll('[data-kx-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.hidden = count === 0;
      if (pop) { el.classList.remove('kx-cart-pop'); void el.offsetWidth; el.classList.add('kx-cart-pop'); }
    });
  }
  function escapeHtml(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function getCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (c) { noteCodes(c); return c; });
  }
  /* Discount codes on the cart. Magic Checkout does not carry them, so a bag with a working code checks out on Shopify's checkout.
     Codes that no longer apply (an ended offer still saved on an old cart) don't count, so those bags keep Magic. */
  var cartCodes = [];
  function noteCodes(cart) {
    cartCodes = ((cart && cart.discount_codes) || []).filter(function (d) { return d.applicable; }).map(function (d) { return d.code; });
    markCodeCheckout();
  }
  function markCodeCheckout() {
    document.querySelectorAll('.kx-bag__form').forEach(function (f) {
      if (cartCodes.length) f.setAttribute('data-magicx', 'inactive');
      else if (!f.hasAttribute('data-kx-magic-keep')) f.removeAttribute('data-magicx');
    });
  }
  function qtyByVariant(cart) {
    var map = {};
    (cart.items || []).forEach(function (it) { map[it.variant_id] = (map[it.variant_id] || 0) + it.quantity; });
    return map;
  }

  /* ---------- Bag drawer (KEOS_CART_AND_CHECKOUT.md · A01–B07) ---------- */
  var BAG_SECTION = 'kx-cart-drawer';
  var ORDER_KEY = 'kx_bag_order';
  var justAdded = null;
  var bagTrigger = null;

  function bagPost(url, body) {
    body.sections = BAG_SECTION;
    body.sections_url = window.location.pathname;
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) {
      return r.json().then(function (d) {
        if (!r.ok) { var err = new Error(d.description || d.message || 'Could not update your bag. Try again.'); err.status = r.status; throw err; }
        return d;
      });
    }, function () { throw new Error('No connection. Try again.'); });
  }
  function readOrder() { try { return JSON.parse(sessionStorage.getItem(ORDER_KEY) || '[]'); } catch (e) { return []; } }
  function writeOrder(o) { try { sessionStorage.setItem(ORDER_KEY, JSON.stringify(o)); } catch (e) { /* storage unavailable */ } }
  // Keep every line where the shopper last saw it: a size change must not jump the line to the top
  function applyOrder(panel) {
    var list = panel.querySelector('[data-kx-bag-lines]');
    if (!list) return;
    var order = readOrder();
    var lines = Array.prototype.slice.call(list.children);
    lines.sort(function (a, b) {
      var ia = order.indexOf(a.getAttribute('data-variant')), ib = order.indexOf(b.getAttribute('data-variant'));
      if (ia === -1 && ib === -1) return 0;
      if (ia === -1) return -1;
      if (ib === -1) return 1;
      return ia - ib;
    });
    lines.forEach(function (li) { list.appendChild(li); });
    writeOrder(lines.map(function (li) { return li.getAttribute('data-variant'); }));
  }
  function markJust(panel) {
    if (!justAdded) return;
    var tag = panel.querySelector('[data-kx-line][data-variant="' + justAdded + '"] [data-kx-just]');
    if (tag) tag.hidden = false;
  }
  function renderBag(html) {
    if (!html) return;
    var fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-kx-bag-panel]');
    if (!fresh) return;
    document.querySelectorAll('[data-kx-bag-panel]').forEach(function (panel) {
      panel.innerHTML = fresh.innerHTML;
      applyOrder(panel);
      markJust(panel);
    });
    markCodeCheckout();
    removeTrialLines();
  }
  function refreshBag() {
    return fetch('/?sections=' + BAG_SECTION, { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (d) { renderBag(d[BAG_SECTION]); })
      .catch(function () {});
  }
  function bagError(msg) {
    document.querySelectorAll('[data-kx-bag-error]').forEach(function (el) { el.textContent = msg || 'Could not update your bag. Try again.'; el.hidden = false; });
  }
  // The free trial bag has its own checkout; it must never sit in the main cart
  var trialBusy = false;
  function removeTrialLines() {
    var t = document.querySelector('[data-kx-bag-panel] [data-kx-trial-line]');
    if (!t || trialBusy) return;
    trialBusy = true;
    bagChange({ line: Number(t.getAttribute('data-kx-line')), quantity: 0 }).catch(function () {}).then(function () { trialBusy = false; });
  }
  function bagChange(body) {
    return bagPost('/cart/change.js', body).then(function (cart) {
      renderBag(cart.sections && cart.sections[BAG_SECTION]);
      syncCards(cart);
      setCartCount(cart.item_count, true);
      return cart;
    });
  }
  function bagAdd(variantId, qty) {
    return bagPost('/cart/add.js', { items: [{ id: Number(variantId), quantity: qty || 1 }] }).then(function (res) {
      justAdded = String(variantId);
      renderBag(res.sections && res.sections[BAG_SECTION]);
      return getCart().then(function (cart) { syncCards(cart); setCartCount(cart.item_count, true); return cart; });
    });
  }

  function bagWrap() { return document.querySelector('[data-kx-bag]'); }
  function openBag(trigger, silent) {
    var wrap = bagWrap();
    if (!wrap) { window.location.href = '/cart'; return; }
    bagTrigger = trigger || document.activeElement;
    closeMenus();
    closeDrawers(true);
    wrap.hidden = false;
    document.documentElement.style.overflow = 'hidden';
    var close = wrap.querySelector('.kx-bag__close');
    if (close) close.focus();
    if (!silent) track('ViewCart', {});
  }
  function closeBag() {
    var wrap = bagWrap();
    if (!wrap || wrap.hidden) return;
    wrap.hidden = true;
    document.documentElement.style.overflow = '';
    justAdded = null;
    wrap.querySelectorAll('[data-kx-just]').forEach(function (el) { el.hidden = true; });
    if (bagTrigger && bagTrigger.getClientRects && bagTrigger.getClientRects().length === 0) {
      var cta = bagTrigger.closest && bagTrigger.closest('[data-kx-cta]');
      var alt = cta && cta.querySelector('[data-kx-qty-step]');
      if (alt) bagTrigger = alt;
    }
    if (bagTrigger && typeof bagTrigger.focus === 'function') bagTrigger.focus();
  }
  window.KeosBag = { add: bagAdd, open: function (t) { openBag(t || null, true); }, refresh: refreshBag };

  /* ---------- Checkout for the whole bag: Razorpay Magic Checkout when it is live, Shopify checkout otherwise ----------
     Magic opens from any click on button[type="button"][name="checkout"], so we click the hidden one in the layout.
     If Magic is off, not live or fails to open, fall back to /checkout. */
  function startCheckout() {
    if (cartCodes.length) { window.location.href = '/checkout'; return; }
    var go = document.querySelector('[data-kx-magic-go]');
    var magic = go && document.getElementById('RazorpayMagicSopcConfig') && window.Razorpay;
    if (!magic) { window.location.href = '/checkout'; return; }
    go.click();
    var waited = 0;
    (function check() {
      var open = document.documentElement.classList.contains('razorpay-magic-scroll') ||
        Array.prototype.some.call(document.querySelectorAll('.razorpay-container, .razorpay-sopc-container, iframe[src*="razorpay.com"]'), function (el) {
          return el.offsetWidth > 200 && el.offsetHeight > 200 && getComputedStyle(el).display !== 'none';
        });
      if (open) return;
      waited += 250;
      if (waited >= 4000) { window.location.href = '/checkout'; return; }
      setTimeout(check, 250);
    })();
  }
  window.KeosCheckout = startCheckout;

  /* ---------- Discount codes in the bag: one-tap offer code, a code box, remove ---------- */
  function codeMsg(text, isErr) {
    document.querySelectorAll('[data-kx-code-msg]').forEach(function (el) {
      el.textContent = text || '';
      el.classList.toggle('is-err', !!isErr);
      el.hidden = !text;
    });
  }
  function setCode(code) {
    return bagPost('/cart/update.js', { discount: code }).then(function (res) {
      renderBag(res.sections && res.sections[BAG_SECTION]);
      return getCart();
    });
  }
  function applyCode(code) {
    code = String(code || '').trim().toUpperCase();
    if (!code) return;
    codeMsg('Applying ' + code + '…');
    setCode(code).then(function (cart) {
      var hit = (cart.discount_codes || []).filter(function (d) { return String(d.code).toUpperCase() === code; })[0];
      if (!hit) { codeMsg(code + " isn't a valid code.", true); return; }
      if (hit.applicable) { codeMsg(''); track('ApplyCode', { code: code }); return; }
      codeMsg(code === 'SECOND20'
        ? 'SECOND20 is saved. It applies at checkout once you enter the phone number or email from your first order.'
        : code + ' is saved and will be checked at checkout. It only works on Keos and Keos+ recipes.');
    }).catch(function (e) { codeMsg((e && e.message) || 'Could not apply the code. Try again.', true); });
  }
  document.addEventListener('click', function (e) {
    var a = e.target.closest('[data-kx-apply-code]');
    if (a) { e.preventDefault(); applyCode(a.getAttribute('data-kx-apply-code')); return; }
    if (e.target.closest('[data-kx-remove-code]')) {
      e.preventDefault();
      setCode('').then(function () { codeMsg(''); }).catch(function () { codeMsg('Could not remove the code. Try again.', true); });
    }
  });
  document.addEventListener('submit', function (e) {
    var f = e.target.closest('[data-kx-code-form]');
    if (!f) return;
    e.preventDefault();
    applyCode(f.querySelector('input[name="code"]').value);
  });

  /* ---------- Free bag through Magic: tidy up afterwards ----------
     The free-bag flow parks the shopper's bag (localStorage keos_bag_parked) and checks out the trial bag alone.
     Whenever Magic is not open, the trial bag must not stay in a normal bag, and the parked items come back. */
  var TRIAL = 'keos-plus-free-trial-bag';
  var tidying = false;
  function magicOpen() { return document.documentElement.classList.contains('razorpay-magic-scroll'); }
  function tidyTrial() {
    if (tidying || magicOpen()) return;
    var parked = null;
    try { parked = JSON.parse(localStorage.getItem('keos_bag_parked') || 'null'); } catch (e) { parked = null; }
    tidying = true;
    getCart().then(function (cart) {
      var trial = cart.items.filter(function (it) { return it.handle === TRIAL; });
      if (!trial.length && !parked) return null;
      var updates = {};
      trial.forEach(function (it) { updates[it.key] = 0; });
      var step = trial.length ? bagPost('/cart/update.js', { updates: updates, attributes: { Source: '', Species: '', 'Pet name': '' } }) : Promise.resolve();
      return step.then(function () {
        if (!parked || !parked.items || !parked.items.length) return null;
        return bagPost('/cart/add.js', { items: parked.items }).catch(function () { return null; });
      }).then(function () {
        try { localStorage.removeItem('keos_bag_parked'); } catch (e) { /* storage unavailable */ }
        return refreshBag();
      });
    }).catch(function () { /* leave the bag as it is */ }).then(function () { tidying = false; });
  }
  // after Magic closes (order placed or not), and on every page load
  new MutationObserver(function () {
    if (!magicOpen() && document.documentElement.getAttribute('data-kx-magic-was-open') === '1') {
      document.documentElement.removeAttribute('data-kx-magic-was-open');
      setTimeout(tidyTrial, 800);
    } else if (magicOpen()) {
      document.documentElement.setAttribute('data-kx-magic-was-open', '1');
    }
  }).observe(document.documentElement, { attributes: true, attributeFilter: ['class'] });
  tidyTrial();

  function sizeChange(li, newId) {
    var oldId = li.getAttribute('data-variant');
    var qty = Number(li.getAttribute('data-qty')) || 1;
    var line = Number(li.getAttribute('data-kx-line'));
    if (!newId || String(newId) === oldId) return;
    li.classList.add('is-busy');
    var order = readOrder();
    var pos = order.indexOf(oldId);
    var removed = false;
    bagPost('/cart/change.js', { line: line, quantity: 0 })
      .then(function () { removed = true; return bagPost('/cart/add.js', { items: [{ id: Number(newId), quantity: qty }] }); })
      .then(function (res) {
        if (pos > -1) { order[pos] = String(newId); writeOrder(order); }
        renderBag(res.sections && res.sections[BAG_SECTION]);
        track('CartSizeChange', { from: oldId, to: String(newId) });
        return getCart().then(function (c) { syncCards(c); setCartCount(c.item_count, false); });
      })
      .catch(function (err) {
        var restore = removed ? bagPost('/cart/add.js', { items: [{ id: Number(oldId), quantity: qty }] }).catch(function () {}) : Promise.resolve();
        restore.then(function () { return refreshBag(); }).then(function () { bagError(err.message); });
      });
  }

  /* Card CTA: "Add" becomes a − n + counter once the variant is in the bag */
  function renderCta(cta, qty) {
    var add = cta.querySelector('[data-kx-add]');
    var box = cta.querySelector('[data-kx-qty]');
    if (!add || !box) return;
    box.querySelector('[data-kx-qty-val]').textContent = qty;
    add.hidden = qty > 0;
    box.hidden = qty <= 0;
  }
  var lastMap = {};
  function syncCards(cart) {
    var map = qtyByVariant(cart);
    lastMap = map;
    document.querySelectorAll('[data-kx-cta]').forEach(function (cta) {
      renderCta(cta, map[cta.getAttribute('data-kx-cta')] || 0);
    });
    setCartCount(cart.item_count, false);
  }
  function refreshCartCount() { return getCart().then(syncCards).catch(function () {}); }

  /* Card size pills (C04): switch price, unit and which variant "Add" adds, without leaving the page */
  document.addEventListener('click', function (e) {
    var pill = e.target.closest('[data-kx-pill]');
    if (!pill || pill.disabled) return;
    e.preventDefault();
    var card = pill.closest('[data-kx-card]');
    if (!card) return;
    var id = pill.getAttribute('data-kx-pill');
    card.querySelectorAll('[data-kx-pill]').forEach(function (b) { b.setAttribute('aria-pressed', b === pill ? 'true' : 'false'); });
    var price = card.querySelector('[data-kx-card-price]');
    if (price) price.textContent = pill.getAttribute('data-price');
    var unit = card.querySelector('[data-kx-card-unit]');
    var u = pill.getAttribute('data-unit');
    if (unit) unit.textContent = pill.getAttribute('data-title') + (u ? ' · ' + u : '');
    var cta = card.querySelector('[data-kx-cta]');
    var add = card.querySelector('[data-kx-add]');
    if (cta && add) {
      cta.setAttribute('data-kx-cta', id);
      add.setAttribute('data-kx-add', id);
      add.setAttribute('data-kx-price', Number(pill.getAttribute('data-cents')) / 100);
      add.setAttribute('data-kx-meta', pill.getAttribute('data-title') + ' · ' + pill.getAttribute('data-price'));
      add.setAttribute('aria-label', 'Add ' + (add.getAttribute('data-kx-name') || '') + ', ' + pill.getAttribute('data-title') + ', to bag');
      renderCta(cta, lastMap[id] || 0);
    }
    card.querySelectorAll('[data-kx-card-link]').forEach(function (a) {
      try { var url = new URL(a.href, location.origin); url.searchParams.set('variant', id); a.href = url.pathname + url.search; } catch (err) { /* keep link */ }
    });
    card.setAttribute('data-kx-cur-cents', pill.getAttribute('data-cents'));
    document.dispatchEvent(new CustomEvent('kx:card-size', { detail: { card: card } }));
  });

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-kx-add]');
    if (!btn || btn.disabled) return;
    e.preventDefault();
    var label = btn.querySelector('[data-kx-add-label]');
    var original = label ? label.textContent : '';
    var id = btn.getAttribute('data-kx-add');
    var name = btn.getAttribute('data-kx-name') || '';
    var meta = btn.getAttribute('data-kx-meta') || '';
    btn.disabled = true;
    btn.setAttribute('aria-busy', 'true');
    if (label) label.textContent = 'Adding';
    bagAdd(id, 1)
      .then(function (cart) {
        btn.removeAttribute('aria-busy');
        btn.classList.add('is-added');
        if (label) label.textContent = 'Added';
        announce('Added ' + name + ' ' + meta.split(' · ')[0] + '. ' + cart.item_count + (cart.item_count === 1 ? ' item' : ' items') + ' in bag.');
        track('AddToCart', { content_ids: [id], content_type: 'product', value: Number(btn.getAttribute('data-kx-price')) || undefined, currency: 'INR' }, true);
        setTimeout(function () {
          btn.classList.remove('is-added');
          btn.disabled = false;
          if (label) label.textContent = original;
          syncCards(cart);
          openBag(btn, true);
        }, 600);
      })
      .catch(function (err) {
        btn.removeAttribute('aria-busy');
        btn.disabled = false;
        if (label) label.textContent = 'Try again';
        showToast('<div class="kx-toast__body"><strong>That did not go into your bag</strong><span>' + escapeHtml(err.message) + '</span></div>');
      });
  });

  document.addEventListener('click', function (e) {
    var step = e.target.closest('[data-kx-qty-step]');
    if (!step || step.disabled) return;
    e.preventDefault();
    var cta = step.closest('[data-kx-cta]');
    var box = step.closest('[data-kx-qty]');
    var id = cta.getAttribute('data-kx-cta');
    var current = parseInt(box.querySelector('[data-kx-qty-val]').textContent, 10) || 0;
    var next = Math.max(0, current + Number(step.getAttribute('data-kx-qty-step')));
    var buttons = box.querySelectorAll('button');
    buttons.forEach(function (b) { b.disabled = true; });
    box.setAttribute('aria-busy', 'true');
    bagPost('/cart/change.js', { id: String(id), quantity: next })
      .then(function (cart) {
        renderBag(cart.sections && cart.sections[BAG_SECTION]);
        var got = qtyByVariant(cart)[id] || 0;
        syncCards(cart);
        setCartCount(cart.item_count, true);
        var name = cta.querySelector('[data-kx-add]').getAttribute('data-kx-name') || 'Item';
        if (got < next) announce('Only ' + got + ' available. We changed the quantity to ' + got + '.');
        else announce(got === 0 ? name + ' removed from bag.' : got + ' ' + name + ' in bag.');
        if (got === 0) { var add = cta.querySelector('[data-kx-add]'); if (add) add.focus(); }
      })
      .catch(function (err) {
        showToast('<div class="kx-toast__body"><strong>Could not update your bag</strong><span>' + escapeHtml(err.message) + '</span></div>');
      })
      .then(function () {
        buttons.forEach(function (b) { b.disabled = false; });
        box.removeAttribute('aria-busy');
      });
  });

  // Bag interactions (drawer and /cart page share the markup)
  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-kx-cart-open]');
    if (opener && bagWrap()) { e.preventDefault(); openBag(opener); return; }
    if (e.target.closest('[data-kx-bag-close]')) { e.preventDefault(); closeBag(); return; }

    var qtyLink = e.target.closest('[data-kx-line-qty]');
    if (qtyLink) {
      e.preventDefault();
      var li = qtyLink.closest('[data-kx-line]');
      var q = Number(qtyLink.getAttribute('data-kx-line-qty'));
      var max = li.getAttribute('data-max');
      var capped = false;
      if (max !== null && q > Number(max)) { q = Math.max(0, Number(max)); capped = true; }
      var variant = li.getAttribute('data-variant');
      var size = li.getAttribute('data-size');
      li.classList.add('is-busy');
      bagChange({ line: Number(li.getAttribute('data-kx-line')), quantity: q })
        .then(function () {
          if (!capped) return;
          document.querySelectorAll('[data-kx-line][data-variant="' + variant + '"] [data-kx-line-msg]').forEach(function (m) {
            m.textContent = 'Only ' + q + ' left in ' + size + '. We changed the quantity to ' + q + '.';
            m.hidden = false;
          });
        })
        .catch(function (err) { li.classList.remove('is-busy'); bagError(err.message); });
      return;
    }

    var sw = e.target.closest('[data-kx-line-switch]');
    if (sw) { e.preventDefault(); sizeChange(sw.closest('[data-kx-line]'), sw.getAttribute('data-kx-line-switch')); return; }

    var xs = e.target.closest('[data-kx-xs-add]');
    if (xs) {
      e.preventDefault();
      xs.disabled = true;
      var xid = xs.getAttribute('data-kx-xs-add');
      bagAdd(xid, 1)
        .then(function (cart) {
          track('AddToCart', { content_ids: [xid], content_type: 'product', currency: 'INR' }, true);
          announce('Added ' + (xs.getAttribute('data-kx-name') || '') + '. ' + cart.item_count + ' items in bag.');
        })
        .catch(function (err) { xs.disabled = false; bagError(err.message); });
      return;
    }

  });
  // Razorpay Magic Checkout takes over checkout clicks in the document capture phase and stops them there,
  // so checkout tracking listens on window, which runs first.
  window.addEventListener('click', function (e) {
    var co = e.target.closest && e.target.closest('[data-kx-checkout]');
    if (co) track('InitiateCheckout', { value: Number(co.getAttribute('data-value')), currency: 'INR', num_items: Number(co.getAttribute('data-items')) }, true);
  }, true);
  document.addEventListener('change', function (e) {
    var sel = e.target.closest('[data-kx-line-size]');
    if (sel) sizeChange(sel.closest('[data-kx-line]'), sel.value);
  });

  /* ---------- Header: mega menu (M02), mobile drawer (M03), scroll state ---------- */
  var OPEN_DELAY = 120, CLOSE_DELAY = 250;
  function syncDim() {
    document.documentElement.classList.toggle('kx-mega-open', !!document.querySelector('[data-kx-menu].is-open [data-kx-mega]'));
  }
  function setMenu(m, open) {
    clearTimeout(m._t);
    m.classList.toggle('is-open', open);
    if (!open) m._viaHover = false;
    var b = m.querySelector('[data-kx-menu-toggle]');
    if (b) b.setAttribute('aria-expanded', open ? 'true' : 'false');
    syncDim();
  }
  function closeMenus(except) {
    document.querySelectorAll('[data-kx-menu].is-open').forEach(function (m) { if (m !== except) setMenu(m, false); });
  }
  function initMenus() {
    document.querySelectorAll('[data-kx-menu]').forEach(function (m) {
      if (m._kxBound) return;
      m._kxBound = true;
      m.addEventListener('pointerenter', function (e) {
        if (e.pointerType !== 'mouse') return;
        clearTimeout(m._t);
        if (m.classList.contains('is-open')) return;
        m._t = setTimeout(function () { closeMenus(m); setMenu(m, true); m._viaHover = true; }, OPEN_DELAY);
      });
      m.addEventListener('pointerleave', function (e) {
        if (e.pointerType !== 'mouse') return;
        clearTimeout(m._t);
        m._t = setTimeout(function () { setMenu(m, false); }, CLOSE_DELAY);
      });
      // Tab past the last link (or anywhere outside) closes the panel
      m.addEventListener('focusout', function (e) {
        if (e.relatedTarget && !m.contains(e.relatedTarget)) setMenu(m, false);
      });
    });
  }

  var drawerTrigger = null;
  function openDrawer(btn) {
    var drawer = document.getElementById(btn.getAttribute('aria-controls'));
    if (!drawer) return;
    drawerTrigger = btn;
    drawer.hidden = false;
    document.body.style.overflow = 'hidden';
    btn.setAttribute('aria-expanded', 'true');
    var close = drawer.querySelector('[data-kx-drawer-close]');
    if (close) close.focus();
  }
  function closeDrawers(silent) {
    var wasOpen = false;
    document.querySelectorAll('[data-kx-drawer]').forEach(function (d) { if (!d.hidden) wasOpen = true; d.hidden = true; });
    document.body.style.overflow = '';
    document.querySelectorAll('[data-kx-drawer-open]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
    if (wasOpen && drawerTrigger && !silent) drawerTrigger.focus();
  }

  document.addEventListener('click', function (e) {
    var toggle = e.target.closest('[data-kx-menu-toggle]');
    if (toggle) {
      var menu = toggle.closest('[data-kx-menu]');
      // A click right after a hover-open keeps it open instead of toggling it shut
      if (menu.classList.contains('is-open') && menu._viaHover) { menu._viaHover = false; return; }
      var open = !menu.classList.contains('is-open');
      closeMenus(menu);
      setMenu(menu, open);
      return;
    }
    if (!e.target.closest('[data-kx-menu]')) closeMenus();

    if (e.target.closest('[data-kfb-open]') && document.querySelector('[data-kfb-modal]')) { closeMenus(); closeDrawers(); }

    var drawerBtn = e.target.closest('[data-kx-drawer-open]');
    if (drawerBtn) { openDrawer(drawerBtn); return; }
    if (e.target.closest('[data-kx-drawer-close]')) closeDrawers();
  });
  document.addEventListener('keydown', function (e) {
    var bag = document.querySelector('[data-kx-bag]:not([hidden]) .kx-bag');
    if (bag && e.key === 'Escape') { e.preventDefault(); closeBag(); return; }
    if (bag && e.key === 'Tab') {
      var bf = Array.prototype.filter.call(bag.querySelectorAll('a[href], button:not([disabled]), select, input'), function (el) { return el.getClientRects().length; });
      if (bf.length) {
        if (e.shiftKey && document.activeElement === bf[0]) { e.preventDefault(); bf[bf.length - 1].focus(); }
        else if (!e.shiftKey && document.activeElement === bf[bf.length - 1]) { e.preventDefault(); bf[0].focus(); }
      }
      return;
    }
    if (e.key === 'Escape') {
      var open = document.querySelector('[data-kx-menu].is-open');
      if (open) {
        setMenu(open, false);
        var b = open.querySelector('[data-kx-menu-toggle]');
        if (b) b.focus();
        return;
      }
      closeDrawers();
      return;
    }
    // Keep Tab inside the open drawer
    if (e.key === 'Tab') {
      var d = document.querySelector('[data-kx-drawer]:not([hidden])');
      if (!d) return;
      var f = Array.prototype.filter.call(d.querySelectorAll('a[href], button, summary, input, select'), function (el) { return el.getClientRects().length; });
      if (!f.length) return;
      if (e.shiftKey && document.activeElement === f[0]) { e.preventDefault(); f[f.length - 1].focus(); }
      else if (!e.shiftKey && document.activeElement === f[f.length - 1]) { e.preventDefault(); f[0].focus(); }
    }
  });
  window.addEventListener('scroll', function () {
    document.documentElement.classList.toggle('kx-scrolled', window.scrollY > 8);
  }, { passive: true });

  /* ---------- Announcement rotator ---------- */
  function initRotator() {
    document.querySelectorAll('[data-kx-rotator]').forEach(function (root) {
      var items = root.querySelectorAll('[data-kx-rotator-item]');
      if (items.length < 2 || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      var dots = root.querySelectorAll('[data-kx-rotator-dot]');
      var i = 0;
      setInterval(function () {
        items[i].classList.remove('is-on');
        if (dots[i]) dots[i].classList.remove('is-on');
        i = (i + 1) % items.length;
        items[i].classList.add('is-on');
        if (dots[i]) dots[i].classList.add('is-on');
      }, 4500);
    });
  }

  function init() {
    applySpecies(readSpecies() || 'dog');
    initReveal();
    initRotator();
    initMenus();
    if (document.querySelector('[data-kx-cta]')) refreshCartCount();
    document.querySelectorAll('[data-kx-bag-panel]').forEach(applyOrder);
    removeTrialLines();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', function () { initReveal(); initMenus(); refreshCartCount(); });
})();
